export const UMB_USER_IS_DEFAULT_KIND_CONDITION_ALIAS = 'Umb.Condition.User.IsDefaultKind';
